import React from 'react';
import styled from 'styled-components';

const FooterContainer = styled.footer`
  background: linear-gradient(to top,  rgba(33 67 154 / 0.9), rgba(42 127 183 / 0.85), rgba(106, 176, 222, 0.8));
  color: var(--light-text);
  padding: 30px 0;
  text-align: center;
  margin-top: auto;
  box-shadow: 0 -4px 15px rgba(74, 144, 226, 0.2);
  border-top: 3px solid rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(5px);
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;

const HeartIcon = styled.span`
  color: #e25555;
  font-size: 1.2rem;
  margin: 0 5px;
  animation: heartbeat 1.5s ease infinite;

  @keyframes heartbeat {
    0% { transform: scale(1); }
    25% { transform: scale(1.1); }
    50% { transform: scale(1); }
    75% { transform: scale(1.1); }
    100% { transform: scale(1); }
  }
`;

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <FooterContainer>
      <FooterContent>
        <p>
          Créé avec <HeartIcon>♥</HeartIcon> pour mon papa extraordinaire
        </p>
        <p> {currentYear} Fête des Pères</p>
      </FooterContent>
    </FooterContainer>
  );
};

export default Footer;
